var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"id":"LogoImage","src":_vm.logoPath,"alt":_vm.$t('ariaLabel.logo')}}),_c('img',{staticStyle:{"height":"40px"},attrs:{"id":"LogoImageSmall","src":_vm.smallLogoPath,"alt":_vm.$t('ariaLabel.logo')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }